import { combineReducers } from 'redux';
import { loadingBarReducer } from 'react-redux-loading-bar';
import authedUser from './authedUser';
import universities from './universities';
import university from './university';
import supervisors from './supervisors';
import newsSupervisors from './NewsSupervisors';
import officers from './officers';
import buses from './buses';
import drivers from './drivers';
import travels from './travels';
import students from './students';

export default combineReducers({
    authedUser,
    universities,
    university,
    supervisors,
    newsSupervisors,
    officers,
    buses,
    drivers,
    travels,
    students,
    loadingBar: loadingBarReducer,
}) 
